export const INIT_STATE = "UUUUUUUUURRRRRRRRRFFFFFFFFFDDDDDDDDDLLLLLLLLLBBBBBBBBB"
  .split("")
  .map((i, k) => i + ((k % 9) + 1));

const AFTER_MOVE_STATE = {
  F:
    "U1 U2 U3 U4 U5 U6 L9 L6 L3 U7 R2 R3 U8 R5 R6 U9 R8 R9 F7 F4 F1 F8 F5 F2 F9 F6 F3 R7 R4 R1 D4 D5 D6 D7 D8 D9 L1 L2 D1 L4 L5 D2 L7 L8 D3 B1 B2 B3 B4 B5 B6 B7 B8 B9",
  B:
    "R3 R6 R9 U4 U5 U6 U7 U8 U9 R1 R2 D9 R4 R5 D8 R7 R8 D7 F1 F2 F3 F4 F5 F6 F7 F8 F9 D1 D2 D3 D4 D5 D6 L1 L4 L7 U3 L2 L3 U2 L5 L6 U1 L8 L9 B7 B4 B1 B8 B5 B2 B9 B6 B3",
  L:
    "B9 U2 U3 B6 U5 U6 B3 U8 U9 R1 R2 R3 R4 R5 R6 R7 R8 R9 U1 F2 F3 U4 F5 F6 U7 F8 F9 F1 D2 D3 F4 D5 D6 F7 D8 D9 L7 L4 L1 L8 L5 L2 L9 L6 L3 B1 B2 D7 B4 B5 D4 B7 B8 D1",
  R:
    "U1 U2 F3 U4 U5 F6 U7 U8 F9 R7 R4 R1 R8 R5 R2 R9 R6 R3 F1 F2 D3 F4 F5 D6 F7 F8 D9 D1 D2 B7 D4 D5 B4 D7 D8 B1 L1 L2 L3 L4 L5 L6 L7 L8 L9 U9 B2 B3 U6 B5 B6 U3 B8 B9",
  U:
    "U7 U4 U1 U8 U5 U2 U9 U6 U3 B1 B2 B3 R4 R5 R6 R7 R8 R9 R1 R2 R3 F4 F5 F6 F7 F8 F9 D1 D2 D3 D4 D5 D6 D7 D8 D9 F1 F2 F3 L4 L5 L6 L7 L8 L9 L1 L2 L3 B4 B5 B6 B7 B8 B9",
  D:
    "U1 U2 U3 U4 U5 U6 U7 U8 U9 R1 R2 R3 R4 R5 R6 F7 F8 F9 F1 F2 F3 F4 F5 F6 L7 L8 L9 D7 D4 D1 D8 D5 D2 D9 D6 D3 L1 L2 L3 L4 L5 L6 B7 B8 B9 B1 B2 B3 B4 B5 B6 R7 R8 R9",
  // M: "",
  // S: "",
  // E: "",
} as const;
export type Action = keyof typeof AFTER_MOVE_STATE;
export const ActionList: Action[] = Object.keys(AFTER_MOVE_STATE) as Action[];
const ACTION_MAP: Record<Action, number[]> = {} as Record<Action, number[]>;
for (const i of ActionList) {
  const move = AFTER_MOVE_STATE[i].split(" ");
  const m: number[] = [];
  for (let i = 0; i < INIT_STATE.length; i++) {
    const p = INIT_STATE[i];
    const x = INIT_STATE.indexOf(p);
    const y = move.indexOf(p);
    m[y] = x;
  }
  ACTION_MAP[i] = m;
}
export { ACTION_MAP };
